// Phone validation bounds. E.164 caps a full international number (country code
// included) at 15 digits; anything under 8 digits is shorter than any real
// mobile number we accept for WhatsApp/OTP.
export const PHONE_MIN_DIGITS = 8;
export const PHONE_MAX_DIGITS = 15;

// Trailing subscriber digits checked for obviously fake patterns
// ("+971 50 0000000", "+44 7 1234567"...).
export const PHONE_FAKE_PATTERN_TAIL_LENGTH = 7;

export const PHONE_VALIDATION_MESSAGES = {
  missing: 'Phone number is required.',
  tooShort: 'Phone number is too short — check the country code and number.',
  tooLong: 'Phone number is too long — check the country code and number.',
  fakePattern: 'Please enter your real phone number.',
  invalid: 'Please enter a valid phone number for the selected country.',
} as const;
